var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-client-table", {
    ref: "requestedPackagesTable",
    staticClass: "vue-custom-table no-pagination requested-packages",
    attrs: {
      data: _vm.previousRequestedPackages,
      columns: _vm.columns,
      options: _vm.options,
    },
    scopedSlots: _vm._u([
      {
        key: "status",
        fn: function (ref) {
          var row = ref.row
          return [
            _c(
              "Badge",
              {
                class: "ml-0 " + _vm.getBadgeType(_vm.getBadgeMessage(row)),
                attrs: { type: "" },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm._f("capitalize")(_vm.getBadgeMessage(row))) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
      },
      {
        key: "createdAt",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm._f("formatDateHour")(row.createdAt)) +
                "\n  "
            ),
          ]
        },
      },
      {
        key: "actions",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.canResetPin(row)
              ? _c(
                  "span",
                  {
                    directives: [
                      {
                        name: "b-tooltip",
                        rawName: "v-b-tooltip",
                        value: {
                          disabled: _vm.canResetPin(row),
                          title: _vm.$t(
                            "request-package.previousRequestedPackages.youCantResetPin"
                          ),
                          boundary: "viewport",
                        },
                        expression:
                          "{\n        disabled: canResetPin(row),\n        title: $t(\n          'request-package.previousRequestedPackages.youCantResetPin'\n        ),\n        boundary: 'viewport'\n      }",
                      },
                    ],
                    staticClass: "d-lg-inline d-none mr-3",
                  },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "bs-0",
                        attrs: {
                          id: "resetPinButton-" + row.requestId,
                          size: "sm",
                          variant: "white",
                          disabled: !_vm.canResetPin(row),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.togglePackage(row, true)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "text-danger" },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("documents.resetClientPin")) +
                                "\n          "
                            ),
                            _c("icon", {
                              attrs: { name: _vm.getButtonIcon(row, true) },
                            }),
                          ],
                          1
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "b-button",
              {
                staticClass: "d-lg-inline d-none bs-0",
                attrs: {
                  id: "viewDetailsButton-" + row.requestId,
                  size: "sm",
                  variant: "primary",
                },
                on: {
                  click: function ($event) {
                    return _vm.togglePackage(row)
                  },
                },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.$t("global.actions.viewDetails")) +
                    "\n      "
                ),
                _c("icon", { attrs: { name: _vm.getButtonIcon(row) } }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-dropdown",
              {
                staticClass: "d-lg-none",
                attrs: {
                  variant: "transparent",
                  "toggle-class": "text-gray position-static",
                  "no-caret": "",
                  right: "",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "button-content",
                      fn: function () {
                        return [
                          _c("i", { staticClass: "material-icons" }, [
                            _vm._v("more_vert"),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              },
              [
                _vm._v(" "),
                _vm.canResetPin(row)
                  ? _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip",
                            value: {
                              disabled: _vm.canResetPin(row),
                              title: _vm.$t(
                                "request-package.previousRequestedPackages.youCantResetPin"
                              ),
                              boundary: "viewport",
                              placement: "left",
                            },
                            expression:
                              "{\n          disabled: canResetPin(row),\n          title: $t(\n            'request-package.previousRequestedPackages.youCantResetPin'\n          ),\n          boundary: 'viewport',\n          placement: 'left'\n        }",
                          },
                        ],
                      },
                      [
                        _c(
                          "b-dropdown-item",
                          {
                            staticClass: "text-center",
                            attrs: { disabled: !_vm.canResetPin(row) },
                            on: {
                              click: function ($event) {
                                return _vm.togglePackage(row, true)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("documents.resetClientPin")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "b-dropdown-item",
                  {
                    staticClass: "text-center",
                    on: {
                      click: function ($event) {
                        return _vm.togglePackage(row)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.actions.viewDetails")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
      },
      {
        key: "child_row",
        fn: function (ref) {
          var row = ref.row
          return [
            _vm.showResetPin(row.requestId)
              ? _c(
                  "b-row",
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "6", lg: "4" } },
                      [
                        _c(
                          "material-input",
                          [
                            _c("applicant-select", {
                              attrs: {
                                id: "applicant-select-" + row.requestId,
                                multiple: false,
                                placeholder: _vm.$tc(
                                  "documents.selectApplicant",
                                  1
                                ),
                                "applicants-to-exclude":
                                  _vm.getApplicantsToExclude(row),
                              },
                              model: {
                                value: _vm.selectedApplicant[row.requestId],
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.selectedApplicant,
                                    row.requestId,
                                    $$v
                                  )
                                },
                                expression: "selectedApplicant[row.requestId]",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "simple-button",
                          {
                            attrs: {
                              type: "primary btn-sm",
                              loading: _vm.loadingResetPin === row.requestId,
                              disabled: !_vm.selectedApplicant[row.requestId],
                            },
                            on: {
                              click: function ($event) {
                                return _vm.handleResetPin(row)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("global.words.send")) +
                                "\n        "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _c("timeline-consolidated-request", {
                  attrs: { metadata: row.metadata, "expand-on-init": "" },
                }),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }